import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useCallback, useState } from 'react';
import { useDataProvider, useNotify } from 'react-admin';

import { GetB2bCampaignOneResponse } from '@Common/types/bo/b2b/campaigns';

import { Button } from '@sh4res/bo-common/components';
import { exportCampaignDetailedReporting } from '@sh4res/bo-common/components/B2bCampaigns/exportCampaignDetailedReporting';
import { ResourceBasePath } from '@sh4res/bo-common/hooks';
import { getErrorMessage } from '@sh4res/bo-common/utils';

type CampaignAllocationsExportButtonsProps = {
  record: GetB2bCampaignOneResponse;
  resourceBasePath: ResourceBasePath;
};

export function CampaignAllocationsExportButtons({
  record,
  resourceBasePath,
}: CampaignAllocationsExportButtonsProps) {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [isExportingDetailedReporting, setIsExportingDetailedReporting] = useState(false);

  const handleDetailedReportingExport = useCallback(async () => {
    setIsExportingDetailedReporting(true);
    try {
      await exportCampaignDetailedReporting({
        resourceBasePath,
        dataProvider,
        campaignId: record.id,
      });
    } catch (error) {
      notify(getErrorMessage(error), { type: 'error' });
    } finally {
      setIsExportingDetailedReporting(false);
    }
  }, [dataProvider, notify, record.id, resourceBasePath]);

  return (
    <Button
      data-testid="BoExternalCampaignAllocationsExportButtons_DetailedExportButton"
      label="resources.bo_common.b2b.campaigns.dashboard.allocations.export.detailed_label"
      permissions={{
        resource: `${resourceBasePath}campaigns/detailed_reporting`,
        action: 'create',
      }}
      startIcon={<FileDownloadIcon />}
      variant="text"
      size="small"
      disabled={isExportingDetailedReporting}
      onClick={() => void handleDetailedReportingExport()}
    />
  );
}
